import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-full md:flex text-center text-xs text-fau-blue-bright hidden md:border border-fau-blue-bright h-10 w-10 justify-center items-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  id: "progress-bar-mobile",
  class: "flex w-full md:hidden justify-between items-center text-fau-blue-bright uppercase text-xs"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  id: "coce-bar-desktop",
  class: "justify-between flex-grow border border-fau-blue-bright text-fau-blue-bright hidden rounded-full relative md:flex font-bold uppercase text-xs md:font-sm overflow-hidden"
}
const _hoisted_10 = {
  key: 1,
  class: "progress h-full absolute left-0 bg-fau-blue-accent transition-all -z-50",
  style: 'width: 100%;'
}

import { computed, onMounted, ref, watch } from "vue";
import Section from "@/modules/Form/Section";
import { SubmitStatus } from "@/modules/Form/Form";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    _sections: {},
    currentQuestionIndex: {},
    submitStatus: {}
  },
  setup(__props: any) {



function GetCurrentSection(questionIndex: number) {
	if (questionIndex == 0) {
		return __props._sections[0];
	}

	for (let i = 0; i < __props._sections.length; i++) {
		if (__props._sections[i].lower <= questionIndex && questionIndex <= __props._sections[i].upper) {
			//console.log(_sections[i]);
			return __props._sections[i];
		}
	}
	return null;
}

function CalculateProgress(index: number) {
    var i = index;

    var sum_p = 0;

    __props._sections.forEach((s) => {
        var sum_n = s.CalculateProgress(i);
        sum_p += sum_n;
    });

    //console.log(sum_p);

    return parseInt(((sum_p / __props._sections.length) * 100).toFixed(0));
}

onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "footer-progress",
    class: _normalizeClass(["w-full px-8 md:pl-16 py-8 flex gap-4", {
            'not-started': _ctx.submitStatus== _unref(SubmitStatus).USER_ANSWERING,
            completed: _ctx.submitStatus== _unref(SubmitStatus).WAITING_FOR_USER,
        }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.submitStatus==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "100%"))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(CalculateProgress(_ctx.currentQuestionIndex)) + "%", 1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._sections, (section) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (GetCurrentSection(_ctx.currentQuestionIndex)?.name == section.name)
            ? (_openBlock(), _createElementBlock("div", {
                key: section.id,
                class: "mx-2 px-4 py-2 rounded-full border border-fau-blue-accent transition-all"
              }, [
                (_ctx.submitStatus == _unref(SubmitStatus).USER_ANSWERING)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(section.name), 1))
                  : _createCommentVNode("", true),
                (_ctx.submitStatus == _unref(SubmitStatus).PENDING)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "↥"))
                  : _createCommentVNode("", true),
                (_ctx.submitStatus == _unref(SubmitStatus).FAILURE)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "!"))
                  : _createCommentVNode("", true),
                (_ctx.submitStatus == _unref(SubmitStatus).SUCCESS)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✓"))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: section.lower,
                class: "w-1 h-1 flex-grow rounded-full bg-fau-blue-accent"
              }))
        ], 64))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._sections, (s, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["text-center relative flex-grow flex items-center justify-center z-10 border-fau-blue-bright", { 'border-l': i !== 0 }]),
          key: i
        }, [
          _createTextVNode(_toDisplayString(s.name) + " ", 1),
          (_ctx.submitStatus == _unref(SubmitStatus).USER_ANSWERING)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "progress h-full absolute left-0 bg-fau-blue-accent transition-all -z-50",
                style: _normalizeStyle('width: ' + s.progress * 100 + '%;')
              }, null, 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_10))
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})